// extracted by mini-css-extract-plugin
export default {"cls1":"A2iDIT8CFjQUvYeP4Cc_","cls2":"wylJ5RB1Vr50f14IIi2w A2iDIT8CFjQUvYeP4Cc_","hasError":"FFWQfEoivSTmYfa9eLCZ"};